export var SheetState;
(function (SheetState) {
    SheetState[SheetState["Bottom"] = 0] = "Bottom";
    SheetState[SheetState["Docked"] = 1] = "Docked";
    SheetState[SheetState["Top"] = 2] = "Top";
})(SheetState || (SheetState = {}));
//# sourceMappingURL=ion-bottom-sheet-state.js.map